import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from 'react-i18next';

import NotFound from '../../../NotFound';
import InputFilter from '../../../Filters/InputFilter';
import SelectFilter from '../../../Selects/SelectFilter';
import Datepicker from 'react-tailwindcss-datepicker';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import PopupPDF from './popUpPdf';
import FilePresentRoundedIcon from '@mui/icons-material/FilePresentRounded';

import {getPdf, getProdutosVendidos} from '../../../../pages/requests';
import {Theaters} from '@mui/icons-material';
import Spinner from '../../../Spinner';
import LoadingModal from '../../../LoadingModal';
import {Context} from '../../../../Helpers/Auth';
import TablePagination from '../../../TablePagination';
import axios from 'axios';
import moment from 'moment';

function ProdutosVendidos({info}) {
    const {t} = useTranslation();
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {
        prospect,
        produtosVendidos,
        setProdutosVendidos,
        utilizador,
        filtroReferencia,
        setFiltroReferencia,
        filtroDesc,
        setFiltroDesc,
        filtroQuantidade,
        setFiltroQuantidade,
        filtroPreco,
        setFiltroPreco,
        filtroNumEncomenda,
        setFiltroNumEncomenda,
        formattedDateEnc,
        setFormattedDateEnc,
        dataPdf,
        setDataPdf,
        filtroDtEncomenda,
        setFiltroDtEncomenda,
        filtroPrecoTotal,
        setFiltroPrecoTotal,
    } = info;
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [semDados, setSemDados] = useState(false);
    const [numEncomendVenda, setNumEncomendVenda] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [isMobile, setIsMobile] = useState(false);
    const [filtroEquipamentos, setFiltroEquipamentos] = useState(true);

    const {isCard, openCards} = useContext(Context);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    // // FILTROS

    // const [filtroReferencia, setFiltroReferencia] = useState('');
    // const [filtroDesc, setFiltroDesc] = useState('');
    // const [filtroQuantidade, setFiltroQuantidade] = useState(0);
    // const [filtroPreco, setFiltroPreco] = useState(0);
    // const [filtroNumEncomenda, setFiltroNumEncomenda] = useState('');
    // const [formattedDateEnc, setFormattedDateEnc] = useState('');
    // const [dataPdf, setDataPdf] = useState('');
    // const [filtroDtEncomenda, setFiltroDtEncomenda] = useState({
    //     startDate: '',
    //     endDate: '',
    // });

    const ITEMS_PER_PAGE = 15;

    const [totalRegistos, setTotalRegistos] = useState(0);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (produtosVendidos?.length == 0) {
            setSemDados(true);
        } else {
            setSemDados(false);
        }
    }, [produtosVendidos]);

    // useEffect(() => {
    //   if (dataPdf != "") {
    //     setLoading(true);
    //   } else {
    //     setLoading(true);
    //   }
    // }, [dataPdf]);

    useEffect(() => {
        if (filtroDtEncomenda?.startDate == null) {
            setFormattedDateEnc('');
            return;
        }
        const originalDate = filtroDtEncomenda?.startDate;
        const parts = originalDate?.split('-');
        const formadata = `${parts[2]}/${parts[1]}/${parts[0]}`;
        setFormattedDateEnc(parts[2] == undefined ? '' : formadata);
    }, [filtroDtEncomenda]);

    // useEffect(() => {
    //     if (filtroDtExpedicao.startDate == null) {
    //         setFormattedDateExp('');
    //         return;
    //     }
    //     const originalDate = filtroDtExpedicao.startDate;
    //     const parts = originalDate?.split('-');
    //     const formadata = `${parts[2]}/${parts[1]}/${parts[0]}`;
    //     setFormattedDateExp(parts[2] == undefined ? '' : formadata);
    // }, [filtroDtEncomenda]);

    useEffect(() => {
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

        const controller = new AbortController();
        const signal = controller.signal;
        //setLoading(true);

        getProdutosVendidos(
            prospect.codigoCliente,
            lang,
            signal,
            indexOfFirstItem,
            indexOfLastItem - 1,
            filtroReferencia,
            filtroDesc,
            !isNaN(filtroQuantidade) ? Number(filtroQuantidade) : 0,
            !isNaN(filtroPreco) ? Number(filtroPreco) : 0,
            filtroNumEncomenda,
            filtroDtEncomenda.startDate,
            !isNaN(filtroPrecoTotal) ? Number(filtroPrecoTotal) : 0,
            filtroEquipamentos,
        )
            .then(res => {
                if (res.data.success) {
                    setProdutosVendidos(res.data.produtosVendidos);
                    setTotalRegistos(res.data.registos);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                //setLoading(false);
            });
        return () => {
            controller.abort();
        };
    }, [currentPage, filtroReferencia, filtroDesc, filtroQuantidade, filtroPreco, filtroNumEncomenda, filtroDtEncomenda.startDate, filtroPrecoTotal, filtroEquipamentos]);

    function handleGetPdf(produto) {
        setLoading(true);
        let vcrtyp = produto.vcrtyp;
        let id = produto.numDoc;
        getPdf(id, vcrtyp)
            .then(function (response) {
                if (response.data.success) {
                    setDataPdf(response.data.pdf);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <div>
                {dataPdf != '' && <PopupPDF back={() => setDataPdf('')} id={dataPdf}></PopupPDF>}

                <div className="flex-col mb-4">
                    <div>
                        <label className="relative mt-2 inline-flex items-center cursor-pointer">
                            <input type="checkbox" onChange={() => setFiltroEquipamentos(!filtroEquipamentos)} checked={filtroEquipamentos} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('apenasEquipamentos')}</span>
                        </label>
                    </div>
                </div>

                {isMobile || isCard ? (
                    <div>
                        {produtosVendidos?.map((produto, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <span
                                            onClick={() => {
                                                handleGetPdf(produto);
                                            }}
                                            className="flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                            <AttachFileRoundedIcon />
                                        </span>
                                        <div className="flex flex-row">
                                            {produto.refArtigo} - {produto.descArtigo}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('descricao')}:</div> {produto.descArtigo}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('quantidade')}: </div> {produto.qtd}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('precoLiquido')}: </div> {produto.precoLiq}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('numEncVenda')}: </div> {produto.numDoc}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataEnc')}: </div> {moment(produto.data).format(FORMATO_DATA)}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('dataEnc')}: </div> {produto.precoTotal}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                ) : (
                    <div className="relative mt-10  overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className=""></th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('referencia')}
                                        <InputFilter
                                            value={filtroReferencia}
                                            onSearch={value => {
                                                setFiltroReferencia(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3 w-80">
                                        {t('descricao')}
                                        <InputFilter
                                            value={filtroDesc}
                                            onSearch={value => {
                                                setFiltroDesc(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('quantidade')}
                                        <InputFilter
                                            value={filtroQuantidade}
                                            onSearch={value => {
                                                setFiltroQuantidade(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('precoLiquido')}
                                        <InputFilter
                                            value={filtroPreco}
                                            onSearch={value => {
                                                setFiltroPreco(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('numEncVenda')}
                                        <InputFilter
                                            value={filtroNumEncomenda}
                                            onSearch={value => {
                                                setFiltroNumEncomenda(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('dataEnc')}
                                        <Datepicker
                                            displayFormat={FORMATO_DATA}
                                            useRange={false}
                                            asSingle={true}
                                            value={filtroDtEncomenda}
                                            onChange={newValue => {
                                                setFiltroDtEncomenda(newValue);
                                                setCurrentPage(1);
                                            }}
                                            inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('total')}
                                        <InputFilter
                                            value={filtroPrecoTotal}
                                            onSearch={value => {
                                                setFiltroPrecoTotal(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    {/* <th scope="col" className="px-6 py-3 w-80">
                                    {t("dataExp")}

                                    <Datepicker
                                        displayFormat="DD/MM/YYYY"
                                        useRange={false}
                                        asSingle={true}
                                        value={filtroDtExpedicao}
                                        onChange={(newValue) => {
                                            setFiltroDtExpedicao(newValue);
                                        }}
                                        inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                    />
                                </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {produtosVendidos?.map(produto => (
                                    <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                        <th className="px-4  py-1 font-medium text-gray-900  dark:text-white">
                                            <span
                                                onClick={() => {
                                                    handleGetPdf(produto);
                                                }}
                                                className="flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                                <AttachFileRoundedIcon />
                                            </span>
                                        </th>
                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {produto.refArtigo}
                                        </th>
                                        <td className="px-1 py-1">{produto.descArtigo}</td>
                                        <td className="px-6 py-1">{produto.qtd}</td>
                                        <td className="flex justify-end text-blue-600 dark:text-blue-500 px-6 py-1  ">{produto.precoLiq}</td>
                                        <td className="px-6 py-1">{produto.numDoc}</td>
                                        <td className="px-6 py-1">{moment(produto.data).format(FORMATO_DATA)}</td>
                                        <td className="px-6 py-1">{produto.precoTotal}</td>
                                        {/* <td className="px-6 py-1">{produto.dataExpedicao}</td> */}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                )}
            </div>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <LoadingModal />
                    </>
                </div>
            )}
        </>
    );
}

export default ProdutosVendidos;
